// ***************************************************************************************
// onWheel()
// permet de scroller avec la souris
// ***************************************************************************************
export function onMouseWheel(state, event) {
  const { subtitles, subtitlesFiltered, filtered, currentSubtitleId } = state;

  const subs = filtered ? subtitlesFiltered : subtitles;

  let currentIndex = subs.findIndex((x) => x.id === currentSubtitleId);

  if (event.deltaY > 0) {
    // Défilement vers le bas
    const maxValue = subs.length - 1;
    if (currentIndex === maxValue) {
      return currentIndex;
    }

    currentIndex++;
  } else {
    // Défilement vers le haut
    if (currentIndex === 0) {
      return currentIndex;
    }

    currentIndex--;
  }

  return currentIndex;
}

export function onChangeScrollValue(state, scrollValue) {
  const subs = state.filtered ? state.subtitlesFiltered : state.subtitles;

  if (scrollValue < 0) {
    scrollValue = 0;
  }

  if (scrollValue > subs.length - state.nbVisibleLines) {
    scrollValue = subs.length - state.nbVisibleLines + 1;
  }

  return {
    ...state,
    scroll: {
      value: scrollValue,
      hasChanged: true,
    },
  };
}

// ***************************************************************************************
// onScrollKeyDown()
// permet de scroller avec le clavier quand le scroll (input range) a le focus
// ***************************************************************************************
export function onScrollKeyDown(event) {}
